export default __webpack_public_path__ + "static/media/XS4 Original + NEO.5835b433.jpg";